import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IdentificationMethodRoutingModule } from './identification-method-routing.module';
import { IdentificationMethodComponent } from './identification-method.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/core/material';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [IdentificationMethodComponent],
  imports: [
    CommonModule,
    IdentificationMethodRoutingModule,
    TranslateModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class IdentificationMethodModule { }
